export default __webpack_public_path__ + "static/media/thumbnail.da77524f.png";